"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upsellUtils = require("../../utils/upsellUtils");
var _utils = require("../../utils/utils");
var _upsellActions = require("../upsell/upsellActions");
var _productCatalogActions = require("./productCatalogActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  handsets: [],
  productRelationshipOffering: [],
  addresses: []
};
var productCatalogReducer = function productCatalogReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _productCatalogActions.SET_HANDSETS:
      return _objectSpread(_objectSpread({}, state), {}, {
        handsets: payload.handsets
      });
    case _productCatalogActions.SET_PRODUCT_RELATIONSHIP_OFFERING:
      return _objectSpread(_objectSpread({}, state), {}, {
        productRelationshipOffering: (0, _utils.uniquifyObjectsById)(payload.productOffering)
      });
    case _productCatalogActions.SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        productRelationshipOffering: state.productRelationshipOffering.map(function (offering) {
          var _payload$price, _payload$price2, _payload$price3, _payload$price4;
          return offering.id === payload.id && (_payload$price = payload.price) !== null && _payload$price !== void 0 && _payload$price.monthlyPrice && (_payload$price2 = payload.price) !== null && _payload$price2 !== void 0 && _payload$price2.monthlyPeriod && ((_payload$price3 = payload.price) !== null && _payload$price3 !== void 0 && _payload$price3.upfront || ((_payload$price4 = payload.price) === null || _payload$price4 === void 0 ? void 0 : _payload$price4.upfront) === 0) ? _objectSpread(_objectSpread({}, offering), {}, {
            selectedPrice: payload.price,
            paymentOptions: (0, _upsellUtils.createPaymentOptions)(payload.price.monthlyPrice, payload.price.monthlyPeriod, payload.price.unit, payload.price.upfront)
          }) : offering;
        })
      });
    case _upsellActions.UPDATE_SELECTED_UPSELL_VARIANT:
      {
        var newProductRelationshipOffering = state.productRelationshipOffering.map(function (offering) {
          if (offering.id === payload.productId) {
            offering.selectedVariant = payload.variant;
          }
          return offering;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          productRelationshipOffering: newProductRelationshipOffering
        });
      }
    case _upsellActions.CLEAR_SELECTED_UPSELL_PRODUCT:
      {
        var _newProductRelationshipOffering = state.productRelationshipOffering.map(function (offering) {
          return (0, _upsellUtils.resetOffering)(offering);
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          productRelationshipOffering: _newProductRelationshipOffering
        });
      }
    case _upsellActions.REMOVE_SELECTED_UPSELL_PRODUCT:
      {
        var productRelationshipOffering = state.productRelationshipOffering.map(function (offering) {
          if (offering.id === payload.id) {
            return (0, _upsellUtils.resetOffering)(offering);
          }
          return offering;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          productRelationshipOffering: productRelationshipOffering
        });
      }
    case _upsellActions.REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS:
      {
        var _newProductRelationshipOffering2 = state.productRelationshipOffering.map(function (offering) {
          if (offering.id === payload.id) {
            return (0, _upsellUtils.resetOffering)(offering);
          }
          return offering;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          productRelationshipOffering: _newProductRelationshipOffering2
        });
      }
    case _productCatalogActions.FETCH_BROADBAND_ADDRESSES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        addresses: payload.addresses
      });
    default:
      return state;
  }
};
var _default = productCatalogReducer;
exports.default = _default;